var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"right-of-withdrawal w-100 d-flex flex-column align-items-center"},[_c('CoRightOfWithdrawalForm',{staticClass:"w-100"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }